import { render, staticRenderFns } from "./UploadImageList.vue?vue&type=template&id=97ec71c2&scoped=true&"
import script from "./UploadImageList.vue?vue&type=script&lang=js&"
export * from "./UploadImageList.vue?vue&type=script&lang=js&"
import style0 from "./UploadImageList.vue?vue&type=style&index=0&id=97ec71c2&prod&lang=less&"
import style1 from "./UploadImageList.vue?vue&type=style&index=1&id=97ec71c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ec71c2",
  null
  
)

export default component.exports